export const messages = {
  en: {
    prePayFeeOrder: {
      title: 'Prepaid Collection',
      back: 'Back',
      payerObject: 'Payment Object:',
      ownerName: 'Owner Name:',
      buildUpArea: 'Building Area:',
      roomArea: 'Indoor Area:',
      parkingLot: 'Parking Lot:',
      parkingSpace: 'Parking Space:',
      receivableAmount: 'Receivable Amount:',
      paymentTime: 'Payment Time:',
      paymentTimePlaceholder: 'Required, please enter payment time',
      autoDeduction: 'Auto Deduction:',
      yes: 'Yes',
      no: 'No',
      paymentMethod: 'Payment Method:',
      paymentMethodPlaceholder: 'Required, please select payment method',
      remark: 'Remark:',
      remarkPlaceholder: 'Optional, please enter remark',
      feeName: 'Fee Name',
      monthlyPrice: 'Monthly Price',
      description: 'Description',
      months: 'Months',
      startMonth: 'Start Month',
      selectMonthsPlaceholder: 'Please select prepaid months',
      monthsUnit: ' months',
      prepaidAmount: 'Prepaid Amount',
      prepaidUtilities: 'Prepaid Utilities Fee',
      scanPayment: 'Scan Payment',
      submitPayment: 'Submit Payment',
      selectPaymentMethod: 'Please select payment method',
      selectPrepaidFee: 'Please select prepaid fee',
      loadError: 'Failed to load fee rule information',
      loadMeterError: 'Failed to load meter fee rule information'
    },
    prePayFeeOrderConfirm: {
      title: 'Payment Confirmation',
      payerObject: 'Payment Object:',
      receivableAmount: 'Receivable Amount:',
      remark: 'Remark:',
      qrCodeTip: 'Please use WeChat/Alipay to scan the QR code to complete payment',
      generatingQrCode: 'Generating payment QR code...',
      authCode: 'Auth Code',
      authCodePlaceholder: 'Please scan with barcode scanner',
      enterAuthCode: 'Please enter authorization code',
      close: 'Close',
      confirmPayment: 'Confirm Payment',
      qrCodeGenerateFailed: 'Failed to generate payment QR code',
      requestFailed: 'Request failed',
      paymentTimeout: 'Payment status query timeout, please manually confirm payment result later',
      paymentCheckFailed: 'Payment status check failed',
      paymentFailed: 'Payment failed'
    },
    prePayFeeOrderResult: {
      title: 'Payment Result',
      receipt: 'Receipt',
      print: 'Print',
      receiptTitle: 'PREPAID FEE RECEIPT',
      receiptNo: 'Receipt No',
      paymentTime: 'Payment Time',
      paymentMethod: 'Payment Method',
      totalAmount: 'Total Amount',
      operator: 'Operator',
      amount: 'Amount',
      period: 'Period',
      paymentSuccess: 'Payment Successful',
      backToList: 'Back to List',
      viewDetails: 'View Details',
      close: 'Close',
      download: 'Download Receipt',
      receiptFooter: 'Thank you for your payment!',
      loadReceiptFailed: 'Failed to load receipt information',
      downloadFeature: 'Download feature is under development',
      requestFailed: 'Request failed'
    }
  },
  zh: {
    prePayFeeOrder: {
      title: '预付收款',
      back: '返回',
      payerObject: '收费对象:',
      ownerName: '业主名称:',
      buildUpArea: '建筑面积:',
      roomArea: '室内面积:',
      parkingLot: '停车场:',
      parkingSpace: '车位:',
      receivableAmount: '应收金额:',
      paymentTime: '缴费时间:',
      paymentTimePlaceholder: '必填，请填写缴费时间',
      autoDeduction: '自动扣款:',
      yes: '是',
      no: '否',
      paymentMethod: '支付方式:',
      paymentMethodPlaceholder: '必填，请选择支付方式',
      remark: '备注:',
      remarkPlaceholder: '可填，请填写备注',
      feeName: '费用名称',
      monthlyPrice: '月单价',
      description: '说明',
      months: '月份',
      startMonth: '起始月',
      selectMonthsPlaceholder: '请选择预存月份',
      monthsUnit: '个月',
      prepaidAmount: '预收金额',
      prepaidUtilities: '预付水电费',
      scanPayment: '扫码收费',
      submitPayment: '提交收费',
      selectPaymentMethod: '请选择支付方式',
      selectPrepaidFee: '请选择预付费用',
      loadError: '加载费用规则信息失败',
      loadMeterError: '加载水电费规则信息失败'
    },
    prePayFeeOrderConfirm: {
      title: '收费确认',
      payerObject: '付费对象：',
      receivableAmount: '应收金额：',
      remark: '备注：',
      qrCodeTip: '请使用微信/支付宝扫描二维码完成支付',
      generatingQrCode: '正在生成支付二维码...',
      authCode: '授权码',
      authCodePlaceholder: '请用扫码枪扫码',
      enterAuthCode: '请输入授权码',
      close: '关闭',
      confirmPayment: '确定收费',
      qrCodeGenerateFailed: '生成支付二维码失败',
      requestFailed: '请求失败',
      paymentTimeout: '支付状态查询超时，请稍后手动确认支付结果',
      paymentCheckFailed: '支付状态检查失败',
      paymentFailed: '收费失败'
    },
    prePayFeeOrderResult: {
      title: '收费结果',
      receipt: '收据',
      print: '打印',
      receiptTitle: '预付费用收据',
      receiptNo: '收据编号',
      paymentTime: '缴费时间',
      paymentMethod: '支付方式',
      totalAmount: '总计金额',
      operator: '操作员',
      amount: '金额',
      period: '期间',
      paymentSuccess: '支付成功',
      backToList: '返回列表',
      viewDetails: '查看详情',
      close: '关闭',
      download: '下载收据',
      receiptFooter: '感谢您的支付！',
      loadReceiptFailed: '加载收据信息失败',
      downloadFeature: '下载功能开发中',
      requestFailed: '请求失败'
}
  },
  'zh-TW': {
    prePayFeeOrder: {
      title: '預付收款',
      back: '返回',
      payerObject: '收費對象:',
      ownerName: '業主名稱:',
      buildUpArea: '建築面積:',
      roomArea: '室內面積:',
      parkingLot: '停車場:',
      parkingSpace: '車位:',
      receivableAmount: '應收金額:',
      paymentTime: '繳費時間:',
      paymentTimePlaceholder: '必填，請填寫繳費時間',
      autoDeduction: '自動扣款:',
      yes: '是',
      no: '否',
      paymentMethod: '支付方式:',
      paymentMethodPlaceholder: '必填，請選擇支付方式',
      remark: '備註:',
      remarkPlaceholder: '可填，請填寫備註',
      feeName: '費用名稱',
      monthlyPrice: '月單價',
      description: '說明',
      months: '月份',
      startMonth: '起始月',
      selectMonthsPlaceholder: '請選擇預存月份',
      monthsUnit: '個月',
      prepaidAmount: '預收金額',
      prepaidUtilities: '預付水電費',
      scanPayment: '掃碼收費',
      submitPayment: '提交收費',
      selectPaymentMethod: '請選擇支付方式',
      selectPrepaidFee: '請選擇預付費用',
      loadError: '載入費用規則資訊失敗',
      loadMeterError: '載入水電費規則資訊失敗'
    },
    prePayFeeOrderConfirm: {
      title: '收費確認',
      payerObject: '付費對象：',
      receivableAmount: '應收金額：',
      remark: '備註：',
      qrCodeTip: '請使用微信/支付寶掃描二維碼完成支付',
      generatingQrCode: '正在生成支付二維碼...',
      authCode: '授權碼',
      authCodePlaceholder: '請用掃碼槍掃碼',
      enterAuthCode: '請輸入授權碼',
      close: '關閉',
      confirmPayment: '確定收費',
      qrCodeGenerateFailed: '生成支付二維碼失敗',
      requestFailed: '請求失敗',
      paymentTimeout: '支付狀態查詢超時，請稍後手動確認支付結果',
      paymentCheckFailed: '支付狀態檢查失敗',
      paymentFailed: '收費失敗'
    },
    prePayFeeOrderResult: {
      title: '收費結果',
      receipt: '收據',
      print: '列印',
      receiptTitle: '預付費用收據',
      receiptNo: '收據編號',
      paymentTime: '繳費時間',
      paymentMethod: '支付方式',
      totalAmount: '總計金額',
      operator: '操作員',
      amount: '金額',
      period: '期間',
      paymentSuccess: '支付成功',
      backToList: '返回列表',
      viewDetails: '查看詳情',
      close: '關閉',
      download: '下載收據',
      receiptFooter: '感謝您的支付！',
      loadReceiptFailed: '載入收據資訊失敗',
      downloadFeature: '下載功能開發中',
      requestFailed: '請求失敗'
    }
  }
}